import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {
  Typography,
  Card,
} from '@mui/material';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import { API_BASE_URL, API_USERNAME_PATH, UI_COACHING, UI_TEST, UI_RESULT, UI_ORG_STATS, UI_USER_ADMIN } from '../../consts';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import refreshAccessToken from '../../modules/tools/refreshAccessToken';
import axios, { AxiosResponse } from 'axios'
import { Link as RouterLink } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import { UI_SELF_SERVICE } from '../../consts';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { Menu, MenuItem, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import { useNavigate } from "react-router-dom"
import SchoolIcon from '@mui/icons-material/School';
import autoRefreshedExecuteHasAllClientOrgRolesWithToken from '../tools/permissions/hasAllClientOrgRoles';
import { useLanguage } from '../../contexts/LanguageContext';
import { LANG_CODE } from './AppFooter';


const rightLink = {
  fontSize: 20,
  color: 'common.white',
  ml: 3,
  marginLeft: '13px'
};

interface ApiResponse {
  status: number | null;
  username: string | null;
}

const NoUnderlineLink = styled(RouterLink)({
  textDecoration: 'none', // Remove the underline
  color: 'black', // Set the link color
});


// TODO: refactor (it is redundant; also the username path is called twice)
function AppAppBar() {
  // TODO confirm (start)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const ref = React.useRef<HTMLElement | null>(null);
  const [open2, setOpen2] = React.useState(true);
  const [hasAddPermission, setHasAddPermission] = React.useState<boolean | null>(null);
  const [hasOrgAdminPermission, setHasOrgAdminPermission] = React.useState<boolean | null>(null);
  const accessToken = localStorage.getItem('access_token');
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleClick = () => {
    setOpen2(!open2);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
  // TODO confirm (end)

  const [apiResponse, setApiResponse] = React.useState<ApiResponse>({ status: null, username: null });

  React.useEffect(() => {
    const fetchUserData = (accessToken: string | null): Promise<ApiResponse> => {
      return axios.get<ApiResponse>(
        `${API_BASE_URL}${API_USERNAME_PATH}`,
        {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        }
      ).then((response: AxiosResponse<ApiResponse>) => {
        return {
          status: response.status,
          username: response.data.username
          // Add other fields as needed
        };
      });
    };

    const handleRefreshAndFetch = () => {
      refreshAccessToken()
        .then((accessRefreshed: string) => {
          return fetchUserData(accessRefreshed);
        })
        .then(response => {
          setApiResponse({ status: response.status, username: response.username });
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            setApiResponse({ status: 401, username: null });
          } else {
            setApiResponse({ status: error.response && error.response.status ? error.response.status : 500, username: null });
          }
        });
    };

    const access = localStorage.getItem('access_token');
    // Make the API request when the component mounts

    fetchUserData(access)
      .then(response => {
        setApiResponse({ status: response.status, username: response.username });
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          handleRefreshAndFetch();
        } else {
          setApiResponse({ status: error.response && error.response.status ? error.response.status : 500, username: null });
        }
      });
  }, []);


  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await autoRefreshedExecuteHasAllClientOrgRolesWithToken(accessToken, "project", "dummyKey", ["Add"]);
        setHasAddPermission(response.has_all_rights); // Update permission state
      } catch (error) {
        console.error("Error fetching data:", error);
        setHasAddPermission(false); // Default to no permission on error
      }
    };

    fetchData();
  }, [accessToken]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await autoRefreshedExecuteHasAllClientOrgRolesWithToken(accessToken, "project", "dummyKey", ["add"]);
        setHasOrgAdminPermission(response.has_all_rights); // Update permission state
      } catch (error) {
        console.error("Error fetching data:", error);
        setHasOrgAdminPermission(false); // Default to no permission on error
      }
    };

    fetchData();
  }, [accessToken]);

  // // Handle loading state
  // if (hasPermission === null) {
  //   return (
  //     <Box sx={{ mt: 3, mb: 7, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
  //       <Card elevation={0} sx={{ maxWidth: 1000, height: '780px' }} style={{ margin: '0px', padding: '0px' }}>
  //         <Box sx={{ display: 'flex', justifyContent: 'center' }} >
  //           <Typography variant="h5" color="text.primary" sx={{ mt: 0, fontSize: '24px' }}>
  //             Loading...
  //           </Typography>
  //         </Box>
  //       </Card>
  //     </Box>
  //   )
  // }

  // Go to signin page if no permission
  // if (!hasPermission) {
  //   navigate("/sign-in/");
  //   window.scrollTo(0, 0);
  //   return null;
  //   // return <NotFoundPage />;
  // }

  const renderUsernameOrLinks = () => {
    if (apiResponse.status === 200 && apiResponse.username) {
      return (
        <Typography variant="h5" sx={rightLink}>
          <NoUnderlineLink to={UI_SELF_SERVICE}>
            {apiResponse.username}
          </NoUnderlineLink>
        </Typography>
      );
    } else {
      return (
        <>
          <Link
            color="inherit"
            variant="h5"
            underline="hover"
            href="/sign-up/"
            sx={{ ...rightLink, color: 'black' }}
          >
            {'Sign-Up'}
          </Link>
          <Link
            color="inherit"
            variant="h5"
            underline="hover"
            href="/sign-in/"
            sx={{ ...rightLink, color: 'black' }}
          >
            {'Sign-In'}
          </Link>
        </>
      );
    }
  };

  const handleClickPracticePage = () => {
    navigate(UI_COACHING);
  };
  const handleClickTestPage = () => {
    navigate(UI_TEST);
  };
  const handleClickMostRecentResultPage = () => {
    navigate(UI_RESULT);
  };
  const handleOrgStatsPage = () => {
    navigate(UI_ORG_STATS);
  };
  const handleOrgAdminPage = () => {
    navigate(UI_USER_ADMIN);
  };

  const getTopMessage = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Enjoy learning? Here are the options!';
      case LANG_CODE.JA_PROFESSIONAL:
        return 'Enjoy learning? Here are the options!';
      case LANG_CODE.JA_YOUTH:
        return 'Enjoy learning? Here are the options!';
      case LANG_CODE.JA_KID:
        return 'きょうもがんばろう！';
    }
  };

  const getPracticeText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Practice more :)';
      case LANG_CODE.JA_PROFESSIONAL:
        return 'トレーニング';
      case LANG_CODE.JA_YOUTH:
        return 'トレーニング';
      case LANG_CODE.JA_KID:
        return 'れんしゅう';
    }
  };

  const getTestText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Let\'s test!';
      case LANG_CODE.JA_PROFESSIONAL:
        return 'テスト';
      case LANG_CODE.JA_YOUTH:
        return 'テスト';
      case LANG_CODE.JA_KID:
        return 'てすと';
    }
  };

  const getScoreText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'See your scores';
      case LANG_CODE.JA_PROFESSIONAL:
        return 'スコア';
      case LANG_CODE.JA_YOUTH:
        return 'スコア';
      case LANG_CODE.JA_KID:
        return 'てんすう';
    }
  };

  const getHistoricalScoreText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Historical results';
      case LANG_CODE.JA_PROFESSIONAL:
        return '結果の一覧';
      case LANG_CODE.JA_YOUTH:
        return '結果の一覧';
      case LANG_CODE.JA_KID:
        return 'がんばったね！けっかをみよう';
    }
  };

  const getOrgStatsText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Org Statistics';
      case LANG_CODE.JA_PROFESSIONAL:
        return '組織の統計';
      case LANG_CODE.JA_YOUTH:
        return '組織の統計';
      case LANG_CODE.JA_KID:
        return 'そしき の とうけい';
    }
  };

  const getAdminText = () => {
    switch (language) {
      case LANG_CODE.EN_PROFESSIONAL:
        return 'Admin';
      case LANG_CODE.JA_PROFESSIONAL:
        return '管理設定';
      case LANG_CODE.JA_YOUTH:
        return '管理設定';
      case LANG_CODE.JA_KID:
        return 'そしき の かんり';
    }
  };


  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
          <IconButton
            size="large"
            edge="start"
            color="info"
            aria-label="menu"
            sx={{ mr: -3 }}
            onClick={handleMenuOpen}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flex: 1 }} />
          <Link
            variant="h6"
            underline="none"
            color="#212121"
            href="/"
            sx={{ fontSize: 24 }}
          >
            {'Études'}
          </Link>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {renderUsernameOrLinks()}
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Box
        sx={{ height: 0 }}
        ref={ref} // Assign the ref to the Box
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: '100vw',      // Full viewport width
            maxWidth: '100vw',    // Ensure no extra space
            position: 'sticky',
            left: 0,              // Align to the left of the viewport
            right: 0,             // Align to the right as well
            margin: 0,            // Remove any default margin
            padding: 0, // Remove any default padding
          },

        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          mt: 9, // Move the menu a bit lower (2 units down from its original position)
        }}
      >
        <List
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              {getTopMessage()}
            </ListSubheader>
          }
        >
          <ListItemButton onClick={handleClickPracticePage}>
            <ListItemIcon>
              <SendIcon />
            </ListItemIcon>
            <ListItemText primary={getPracticeText()} />
          </ListItemButton>
          <ListItemButton onClick={handleClickTestPage}>
            <ListItemIcon>
              <DraftsIcon />
            </ListItemIcon>
            <ListItemText primary={getTestText()} />
          </ListItemButton>
          <ListItemButton onClick={handleClick}>
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary={getScoreText()} />
            {open2 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open2} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={handleClickMostRecentResultPage}>
                <ListItemIcon>
                  <StarBorder />
                </ListItemIcon>
                <ListItemText primary={getHistoricalScoreText()} />
              </ListItemButton>
            </List>
          </Collapse>
          {hasAddPermission && (
            <ListItemButton onClick={handleOrgStatsPage}>
              <ListItemIcon>
                <SchoolIcon />
              </ListItemIcon>
              <ListItemText primary={getOrgStatsText()} />
            </ListItemButton>
          )}
          {hasOrgAdminPermission && (
            <ListItemButton onClick={handleOrgAdminPage}>
              <ListItemIcon>
                <ManageAccountsIcon />
              </ListItemIcon>
              <ListItemText primary={getAdminText()} />
            </ListItemButton>
          )}
        </List>
        {/* <MenuItem>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Section 1ffffffff
            </AccordionSummary>
            <AccordionDetails>
              Content for section 1
            </AccordionDetails>
          </Accordion>
        </MenuItem>
        <MenuItem>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              Section 2
            </AccordionSummary>
            <AccordionDetails>
              Content for section 2
            </AccordionDetails>
          </Accordion>
        </MenuItem> */}
      </Menu>
    </div>
  );
}

// if we do not need user shown func
// function AppAppBar() {
//   return (
//     <div>
//       <AppBar position="fixed">
//         <Toolbar sx={{ justifyContent: 'space-between', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
//           <Box sx={{ flex: 1 }} />
//           <Link
//             variant="h6"
//             underline="none"
//             color="#212121"
//             href="/"
//             sx={{ fontSize: 24 }}
//           >
//             {'OnkanAI'}
//           </Link>
//           <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
//             <Link
//               color="inherit"
//               variant="h5"
//               underline="hover"
//               href="/sign-up/"
//               sx={{ ...rightLink, color: 'black' }}
//             >
//               {'Sign-Up'}
//             </Link>
//             <Link
//               color="inherit"
//               variant="h5"
//               underline="hover"
//               href="/sign-in/"
//               sx={{ ...rightLink, color: 'black' }}
//             >
//               {'Sign-In'}
//             </Link>
//           </Box>
//         </Toolbar>
//       </AppBar>
//       <Toolbar />
//     </div >
//   );
// }

export default AppAppBar;

// the following is kinda broken ver but just in case to save
{/* <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
          <Box sx={{ flex: 1 }} />
          <Link
            variant="h6"
            underline="none"
            color="#212121"
            href="/"
            sx={{ fontSize: 24 }}
          >
            {'OnkanAI'}
          </Link>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
            <Box sx={{ border: 1, borderColor: 'white', borderRadius: '10px', width: '15%' }} >
              <Typography align='center'>
                <Link
                  color="inherit"
                  variant="h5"
                  underline="hover"
                  href="/sign-in/"
                  sx={{ color: 'black' }}
                >
                  {'SIGN IN'}
                </Link>
              </Typography>
            </Box>
            <Box sx={{ border: 1, borderColor: 'white', borderRadius: '10px', width: '15%' }} >
              <Typography align='center'>
                <Link
                  color="inherit"
                  variant="h5"
                  underline="hover"
                  href="/sign-up/"
                  sx={{ color: 'black' }}
                >
                  {'SIGN UP'}
                </Link>
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar /> */}
